/* ss-cookie-close.js: a clear close (×) on Shopify's cookie bar, and room under the page while it shows.
   Sho, 2026-10-06: the bar must never obstruct, and be easy to see, click, and close. The × is a real
   button that does exactly what "Necessary only" does (it clicks that button), so the choice Shopify
   records is the same. html.ss-cb-open is set only while the bar is on screen; custom.css pads the
   page bottom by the bar's height then, so the last content can always scroll clear of it. */
(function () {
  'use strict';
  var NAME = { pl: 'Zamknij', cs: 'Zavřít', de: 'Schließen', nl: 'Sluiten', en: 'Close' };
  var root = document.documentElement;
  function open(b) {
    var cs = getComputedStyle(b);
    return !b.hasAttribute('data-ss-closing') && cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
  }
  var lastH = '';
  function sync(b) {
    var on = open(b);
    root.classList.toggle('ss-cb-open', on);
    if (!on) return;
    /* from the bar's top edge to the screen bottom: the bar plus any buy bar it rests on */
    var h = Math.max(0, Math.ceil(window.innerHeight - b.getBoundingClientRect().top)) + 'px';
    if (h !== lastH) { lastH = h; root.style.setProperty('--ss-cb-h', h); }
  }
  function wire(b) {
    var decline = b.querySelector('.shopify-pc__banner__btn-decline');
    if (!decline) return false;
    if (!b.querySelector('.ss-cb-x')) {
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'ss-cb-x';
      x.setAttribute('aria-label', (NAME[(root.lang || 'en').slice(0, 2)] || NAME.en) + ': ' + decline.textContent.trim());
      x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      /* Shopify hides its bar only after its consent call answers (seconds on a slow line): close at once, record behind it */
      x.addEventListener('click', function () { b.setAttribute('data-ss-closing', ''); sync(b); decline.click(); });
      b.appendChild(x);
      var queued = false;
      var later = function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; sync(b); }); };
      /* the Jade page shows the bar by CSS once its buy bar arms on scroll; nothing on the bar itself changes */
      window.addEventListener('resize', later, { passive: true });
      window.addEventListener('scroll', later, { passive: true });
      b.addEventListener('transitionend', later);
      /* once the visitor has answered, the bar is gone for good: stop listening */
      document.addEventListener('visitorConsentCollected', function () {
        window.removeEventListener('resize', later); window.removeEventListener('scroll', later);
        setTimeout(function () { sync(b); }, 400);
      });
    }
    new MutationObserver(function () { sync(b); }).observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    sync(b);
    return true;
  }
  function find() { var b = document.getElementById('shopify-pc__banner'); return b && wire(b); }
  if (find()) return;
  var mo = new MutationObserver(function () { if (find()) mo.disconnect(); });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 30000);
})();
